import { render, staticRenderFns } from "./ViewSelect.vue?vue&type=template&id=88042412&scoped=true&"
import script from "./ViewSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./ViewSelect.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88042412",
  null
  
)

export default component.exports